<template>
  <NavBar />
  <BackgroundImage
    :imageUrl="require('@/assets/login/bg.png')"
    :customStyle="{
      minHeight: '100vh',
    }"
  >
    <div class="container">
      <a-flex gap="middle" justify="center" vertical>
        <a-row :gutter="[0, 0]" justify="center">
          <a-col :md="16" :sm="22" :xs="22">
            <a-card class="doctor-card">
              <!-- 医生信息头部 -->
              <div class="header">
                <img 
                  :src="doctorInfo.avatar" 
                  :alt="doctorInfo.name"
                  class="doctor-avatar"
                />
                <div class="doctor-basic">
                  <h1 class="doctor-name">{{ doctorInfo.name }}</h1>
                  <div class="tags">
                    <a-tag 
                      v-for="(tag, index) in doctorInfo.tags" 
                      :key="index"
                      class="doctor-tag"
                      color="blue"
                    >
                      {{ tag.name }}
                    </a-tag>
                  </div>
                </div>
              </div>

              <!-- 专业擅长 -->
              <div class="content-section">
                <h2 class="section-title">专业擅长</h2>
                <p class="specialty-text" v-html="doctorInfo.specialty"></p>
              </div>

              <!-- 医学成就 -->
              <div class="achievements">
                <div 
                  v-for="(achievement, index) in doctorInfo.achievements" 
                  :key="index"
                  class="achievement-item"
                >
                  <h3 class="achievement-title">{{ achievement.title }}</h3>
                  <p class="achievement-desc">{{ achievement.description }}</p>
                </div>
              </div>

              <!-- 常见问题 -->
              <div class="questions-section">
                <h2 class="section-title">您可能还想问</h2>
                <div class="questions-list">
                  <div 
                    v-for="(question, index) in commonQuestions" 
                    :key="index"
                    class="question-item"
                    @click="handleQuestionClick(question)"
                  >
                    <a-button type="text" class="question-btn">
                      <template #icon>
                        <MessageOutlined />
                      </template>
                      {{ question }}
                    </a-button>
                  </div>
                </div>
              </div>
            </a-card>
          </a-col>
        </a-row>
      </a-flex>
    </div>

    <!-- 浮动聊天按钮 -->
    <div class="floating-chat" @click="openChatModal">
      <div class="chat-avatar">
        <img :src="doctorInfo.avatar" :alt="doctorInfo.name" />
      </div>
      <div class="chat-tip">
        <span>点击咨询 {{ doctorInfo.name }} 名老中医数智郎中</span>
      </div>
    </div>

    <!-- 聊天弹窗 -->
    <a-modal
      v-model:open="chatModalVisible"
      :title="`与${doctorInfo.name}医生在线咨询`"
      width="80%"
      :style="{ maxWidth: '800px' }"
      :footer="null"
      :destroyOnClose="true"
      @cancel="closeChatModal"
    >
      <div class="chat-modal-content">
        <iframe 
          ref="chatIframe"
          :src="chatUrl"
          class="chat-iframe"
          allow="microphone; camera; display-capture; document-domain; encrypted-media; fullscreen;"
          sandbox="allow-scripts allow-same-origin"
        ></iframe>
      </div>
    </a-modal>
  </BackgroundImage>
</template>

<script>
import BackgroundImage from "@/components/BackgroundImage.vue";
import NavBar from "@/components/NavBar.vue";
import { MessageOutlined } from "@ant-design/icons-vue";

import api from "@/api";

export default {
  name: "DoctorPage",
  components: {
    BackgroundImage,
    NavBar,
    MessageOutlined,
  },
  data() {
    return {
      chatModalVisible: false,
      chatUrl: "https://agent.qixiaohuang.com:8282",
      doctorInfo: {
        name: "朱国豪",
        avatar: "https://qihuang.oss-cn-qingdao.aliyuncs.com/images/doctor/zhuguohao_1.png?x-oss-process=image/format,webp",
        tags: [
          "中医骨伤科/风湿病科",
          "土家族医药非遗传承人", 
          "中医药传承馆馆长",
          "铜仁市中医药学会名誉会长"
        ],
        specialty: `专业擅长：《土家族医药》医学，开发出多种具有显著疗效的药物制剂。致力于将土家族医药推向国际市场。例如，他发明的"<span class="highlight">神香抗痧抗癌1、2、3号</span>"。通过<span class="highlight">超临界提取技术</span>，显着提高了药物的疗效和安全性。还有治疗心脑血管病糖尿病等10多种疑难疾病的临床制剂也将推出面世。`,
        achievements: [
          {
            title: "医学成就",
            description: "朱国豪医生在土家族医药领域的研究和实践取得了显著成就，特别是在药物制剂的开发和推广方面。"
          },
          {
            title: "国际推广", 
            description: "朱国豪医生积极参与国际交流，致力于将土家族医药推向全球，让更多人了解和受益于这一传统医学。"
          }
        ]
      },
      commonQuestions: [
        "中西医结合是如何治疗妇科肿瘤，具体是...",
        "中药调理能缓解更年期综合征导致的失眠...",
        "川派中医在控制血糖方面有什么特色疗法",
        "土家族医药在治疗风湿病方面有什么独特优势？",
        "神香抗痧抗癌制剂的具体疗效如何？"
      ]
    };
  },
  mounted() {
    // 监听来自iframe的消息
    window.addEventListener('message', this.handleIframeMessage);
    // 根据路由参数加载医生信息
    this.loadDoctorInfo();
  },
  beforeUnmount() {
    // 清理消息监听器
    window.removeEventListener('message', this.handleIframeMessage);
  },
  methods: {
    // 加载医生信息
    async loadDoctorInfo() {
      const doctorId = this.$route.query.id;
      console.log('医生ID:', doctorId);
      
      if (!doctorId) {
        console.log('未提供医生ID，使用默认数据');
        return;
      }
      
      try {
        const response = await api.doctor.getDetail({
          doctor_id: doctorId
        });
        console.log('医生详情:', response);
        // response.data 内容
        // {
        //  bio: "" // 医生简介
        //  doctor_id: 1,
        //  expertise: "" // 专业特长
        //  more: { thumbnail: "" } // 头像
        //  name: "" // 医生姓名
        //  tag: [] // 标签数组
        //  tag_id: "" // 标签ID
        // }
        
        if (response.data) {
          const data = response.data;
          
          // 更新医生信息
          this.doctorInfo = {
            name: data.name || '医生',
            avatar: data.more?.thumbnail || 'https://qihuang.oss-cn-qingdao.aliyuncs.com/images/doctor/default.png',
            tags: Array.isArray(data.tag) ? data.tag : (data.tag ? [data.tag] : []),
            specialty: data.expertise || '暂无专业特长介绍',
            achievements: [
              {
                title: "医生简介",
                description: data.bio || '暂无简介'
              }
            ]
          };
          
          // 更新聊天弹窗标题
          this.$nextTick(() => {
            // 这里可以动态更新弹窗标题
          });
        }
      } catch (error) {
        console.error('获取医生详情失败:', error);
        this.$message.error('获取医生详情失败');
      }
    },
    
    // 处理来自iframe的消息
    handleIframeMessage(event) {
      console.log('收到消息事件:', event);
      console.log('消息来源:', event.origin);
      console.log('消息数据:', event.data);
    },
    
    // 打开聊天弹窗
    openChatModal() {
      this.chatModalVisible = true;
    },
    
    // 关闭聊天弹窗并触发iframe中的停止聊天按钮
    closeChatModal() {
      console.log("关闭聊天弹窗");
      
      // 尝试直接访问iframe内容并点击按钮
      try {
        const iframe = this.$refs.chatIframe;
        console.log('iframe引用:', iframe);
        
        if (iframe) {
          // 尝试多种方式访问iframe的document
          let iframeDoc = null;
          
          try {
            // 方式1：直接访问contentDocument
            iframeDoc = iframe.contentDocument;
            console.log('contentDocument:', iframeDoc);
          } catch (e) {
            console.log('无法访问contentDocument:', e);
          }
          
          if (!iframeDoc) {
            try {
              // 方式2：通过contentWindow访问document
              iframeDoc = iframe.contentWindow.document;
              console.log('contentWindow.document:', iframeDoc);
            } catch (e) {
              console.log('无法通过contentWindow访问document:', e);
            }
          }
          
          if (iframeDoc) {
            console.log('成功访问iframe document，查找.stop-chat按钮');
            const stopButton = iframeDoc.querySelector('.stop-chat');
            console.log('找到的停止按钮:', stopButton);
            
            if (stopButton) {
              stopButton.click();
              console.log('已点击iframe中的.stop-chat按钮');
            } else {
              console.log('未找到.stop-chat按钮，列出所有按钮:');
              const allButtons = iframeDoc.querySelectorAll('button');
              console.log('所有按钮:', allButtons);
              // 尝试查找包含"停止"或"stop"文本的按钮
              Array.from(allButtons).forEach((btn, index) => {
                console.log(`按钮${index}:`, btn.textContent, btn.className);
                if (btn.textContent.includes('停止') || btn.textContent.toLowerCase().includes('stop')) {
                  console.log('找到可能的停止按钮，尝试点击');
                  btn.click();
                }
              });
            }
          } else {
            console.log('无法访问iframe document，可能是跨域限制');
            // 备用方案：使用postMessage
            if (iframe.contentWindow) {
              console.log('尝试使用postMessage方式');
              iframe.contentWindow.postMessage({
                action: 'clickButton',
                selector: '.stop-chat',
                type: 'STOP_CHAT'
              }, '*');
            }
          }
        }
      } catch (error) {
        console.log('操作失败:', error);
      }
      
      // 延迟关闭弹窗
      setTimeout(() => {
        this.chatModalVisible = false;
      }, 300);
    },
    
    // 处理问题点击
    handleQuestionClick(question) {
      // 可以将问题传递给聊天界面或者直接打开聊天窗口
      this.openChatModal();
      // 这里可以添加将问题传递给聊天界面的逻辑
      console.log("点击问题:", question);
    }
  }
};
</script>

<style lang="scss" scoped>
.container {
  padding: 80px 20px 40px;
  min-height: 100vh;
}

.doctor-card {
  border-radius: 16px;
  border: 1.5px solid rgba(255, 255, 255, 0.3);
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(20px);
  box-shadow: 0 8px 32px rgba(16, 65, 181, 0.12);
  overflow: hidden;
  
  :deep(.ant-card-body) {
    padding: 48px;
    
    @media (max-width: 768px) {
      padding: 28px 20px;
    }
  }
}

.header {
  display: flex;
  align-items: flex-start;
  margin-bottom: 40px;
  gap: 28px;
  padding-bottom: 32px;
  border-bottom: 2px solid rgba(94, 123, 243, 0.1);
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding-bottom: 24px;
  }
}

.doctor-avatar {
  width: 140px;
  height: 140px;
  border-radius: 50%;
  object-fit: cover;
  border: 5px solid rgba(94, 123, 243, 0.15);
  box-shadow: 0 4px 16px rgba(94, 123, 243, 0.2);
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 24px rgba(94, 123, 243, 0.3);
  }
  
  @media (max-width: 768px) {
    width: 120px;
    height: 120px;
  }
}

.doctor-basic {
  flex: 1;
}

.doctor-name {
  font-size: 32px;
  font-weight: 700;
  background: linear-gradient(135deg, #1041B5 0%, #5E7BF3 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 20px;
  letter-spacing: 1px;
  
  @media (max-width: 768px) {
    font-size: 26px;
    margin-bottom: 16px;
  }
}

.tags {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  
  @media (max-width: 768px) {
    justify-content: center;
  }
}

.doctor-tag {
  font-size: 13px;
  padding: 8px 16px;
  border-radius: 24px;
  border: 1.5px solid rgba(94, 123, 243, 0.3);
  background: linear-gradient(135deg, rgba(94, 123, 243, 0.08) 0%, rgba(16, 65, 181, 0.05) 100%);
  color: #1041B5;
  font-weight: 500;
  transition: all 0.3s ease;
  
  &:hover {
    border-color: #5E7BF3;
    background: linear-gradient(135deg, rgba(94, 123, 243, 0.15) 0%, rgba(16, 65, 181, 0.1) 100%);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(94, 123, 243, 0.15);
  }
  
  :deep(.ant-tag) {
    margin: 0;
  }
}

.content-section {
  margin-bottom: 36px;
  padding: 24px;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(94, 123, 243, 0.03) 0%, rgba(16, 65, 181, 0.02) 100%);
}

.section-title {
  font-size: 22px;
  font-weight: 700;
  color: #1041B5;
  margin-bottom: 20px;
  position: relative;
  padding-left: 16px;
  display: inline-block;
  
  &::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 5px;
    height: 24px;
    background: linear-gradient(180deg, #5E7BF3 0%, #1041B5 100%);
    border-radius: 3px;
    box-shadow: 0 2px 8px rgba(94, 123, 243, 0.3);
  }
  
  @media (max-width: 768px) {
    font-size: 19px;
  }
}

.specialty-text {
  font-size: 16px;
  line-height: 2;
  color: #333;
  
  :deep(.highlight) {
    color: #d9480f;
    font-weight: 600;
    background: linear-gradient(135deg, rgba(217, 72, 15, 0.12) 0%, rgba(217, 72, 15, 0.08) 100%);
    padding: 3px 8px;
    border-radius: 6px;
    border-bottom: 2px solid rgba(217, 72, 15, 0.3);
  }
  
  @media (max-width: 768px) {
    font-size: 15px;
    line-height: 1.8;
  }
}

.achievements {
  margin-bottom: 36px;
}

.achievement-item {
  margin-bottom: 20px;
  padding: 24px;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(94, 123, 243, 0.06) 0%, rgba(16, 65, 181, 0.04) 100%);
  border-left: 5px solid #5E7BF3;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateX(4px);
    box-shadow: 0 4px 16px rgba(94, 123, 243, 0.15);
    border-left-color: #1041B5;
  }
  
  @media (max-width: 768px) {
    padding: 20px 16px;
  }
}

.achievement-title {
  font-size: 19px;
  font-weight: 700;
  color: #1041B5;
  margin-bottom: 12px;
  
  @media (max-width: 768px) {
    font-size: 17px;
  }
}

.achievement-desc {
  font-size: 16px;
  line-height: 1.8;
  color: #666;
  margin: 0;
  
  @media (max-width: 768px) {
    font-size: 15px;
  }
}

.questions-section {
  margin-bottom: 20px;
  padding: 24px;
  border-radius: 12px;
  background: linear-gradient(135deg, rgba(94, 123, 243, 0.03) 0%, rgba(16, 65, 181, 0.02) 100%);
}

.questions-list {
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.question-item {
  border-radius: 28px;
  border: 1.5px solid rgba(94, 123, 243, 0.25);
  background: linear-gradient(90deg, rgba(149, 142, 246, 0.08) 0%, rgba(140, 194, 248, 0.08) 50%, rgba(94, 123, 243, 0.08) 100%);
  transition: all 0.3s ease;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.5s;
  }
  
  &:hover {
    background: linear-gradient(90deg, rgba(149, 142, 246, 0.15) 0%, rgba(140, 194, 248, 0.15) 50%, rgba(94, 123, 243, 0.15) 100%);
    transform: translateX(4px);
    box-shadow: 0 6px 16px rgba(94, 123, 243, 0.2);
    border-color: #5E7BF3;
    
    &::before {
      left: 100%;
    }
  }
  
  &:active {
    transform: translateX(2px) scale(0.98);
  }
}

.question-btn {
  width: 100%;
  height: auto;
  padding: 14px 24px;
  text-align: left;
  color: #1041B5;
  font-size: 15px;
  font-weight: 500;
  border: none;
  box-shadow: none;
  display: flex;
  align-items: center;
  
  &:hover {
    background: none !important;
    color: #1041B5 !important;
  }
  
  :deep(.anticon) {
    margin-right: 12px;
    color: #5E7BF3;
    font-size: 18px;
  }
  
  @media (max-width: 768px) {
    font-size: 14px;
    padding: 12px 18px;
  }
}

.chat-modal-content {
  height: 600px;
  
  @media (max-width: 768px) {
    height: 500px;
  }
}

.chat-iframe {
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 8px;
}

// 浮动聊天按钮样式
.floating-chat {
  position: fixed;
  right: 30px;
  bottom: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  z-index: 1000;
  animation: pulse 2.5s ease-in-out infinite;
  
  .chat-avatar {
    width: 140px;
    height: 140px;
    border-radius: 50%;
    overflow: hidden;
    border: 4px solid #5E7BF3;
    box-shadow: 0 8px 32px rgba(16, 65, 181, 0.35);
    transition: all 0.4s ease;
    position: relative;
    
    &::before {
      content: '';
      position: absolute;
      top: -2px;
      left: -2px;
      right: -2px;
      bottom: -2px;
      border-radius: 50%;
      background: linear-gradient(45deg, #5E7BF3, #1041B5, #5E7BF3);
      z-index: -1;
      opacity: 0;
      transition: opacity 0.4s ease;
    }
    
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
  
  .chat-tip {
    background: linear-gradient(135deg, #5E7BF3 0%, #1041B5 100%);
    color: white;
    padding: 10px 16px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    box-shadow: 0 6px 20px rgba(16, 65, 181, 0.35);
    transform: translateY(0);
    opacity: 1;
    transition: all 0.4s ease;
    position: relative;
    letter-spacing: 0.5px;
    
    &::before {
      content: '';
      position: absolute;
      top: -8px;
      left: 50%;
      transform: translateX(-50%);
      border-bottom: 8px solid #1041B5;
      border-left: 8px solid transparent;
      border-right: 8px solid transparent;
    }
  }
  
  &:hover {
    animation-play-state: paused;
    
    .chat-avatar {
      transform: scale(1.15) rotate(5deg);
      border-color: #1041B5;
      box-shadow: 0 12px 48px rgba(16, 65, 181, 0.5);
      
      &::before {
        opacity: 1;
        animation: rotate 3s linear infinite;
      }
    }
    
    .chat-tip {
      transform: translateY(-4px);
      box-shadow: 0 8px 28px rgba(16, 65, 181, 0.45);
    }
  }
  
  @media (max-width: 768px) {
    right: 20px;
    bottom: 20px;
    gap: 8px;
    
    .chat-avatar {
      width: 70px;
      height: 70px;
      border-width: 3px;
    }
    
    .chat-tip {
      font-size: 11px;
      padding: 8px 12px;
    }
  }
}

// 旋转动画
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

// 脉动动画
@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.08);
  }
}

// 弹窗样式调整
:deep(.ant-modal) {
  .ant-modal-header {
    background: linear-gradient(135deg, #5E7BF3 0%, #1041B5 100%);
    border-bottom: none;
    padding: 20px 24px;
    border-radius: 12px 12px 0 0;
    
    .ant-modal-title {
      color: white;
      font-weight: 700;
      font-size: 18px;
      letter-spacing: 0.5px;
    }
  }
  
  .ant-modal-close {
    color: white;
    top: 20px;
    right: 20px;
    width: 32px;
    height: 32px;
    
    .ant-modal-close-x {
      width: 32px;
      height: 32px;
      line-height: 32px;
      font-size: 18px;
    }
    
    &:hover {
      color: rgba(255, 255, 255, 0.85);
      background: rgba(255, 255, 255, 0.1);
      border-radius: 50%;
    }
  }
  
  .ant-modal-body {
    padding: 0;
  }
  
  .ant-modal-content {
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 12px 48px rgba(16, 65, 181, 0.2);
  }
}
</style>